var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF6A61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 7h10l.002 10H4V7zM2 17c0 1.104.897 2 2 2h10c1.103 0 2-.896 2-2V5H2v12zM12 2.001L12 .001 6 .001 6 2.001 0 2.001 0 4 18 4 18 2.001z",
    transform: "translate(-1172 -269) translate(1172 270) translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15L8 15 8 9 6 9zM10 15L12 15 12 9 10 9z",
    transform: "translate(-1172 -269) translate(1172 270) translate(7 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.406054fbbbaffd6f7f2f209028a08b42.svg";
export { ForwardRef as ReactComponent };